module.exports = {
  title: 'Dynamic Blur TabBar with Reanimated and Expo Blur',
  author: 'Enzo Manuel Mangano',
  date: '2024-10-15',
  slug: 'dynamic-blur-tabs',
  tags: ['reanimated', 'expo-blur', 'react-navigation', 'expo-router'],
};
